import type { FC } from 'react';
import { Java8FeaturesWrapper } from './Java8Features.styled';

interface Java8FeaturesProps {}

const Java8Features: FC<Java8FeaturesProps> = () => (
 <Java8FeaturesWrapper>
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Java 8 Features</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify">JAVA 8&nbsp;is a major&nbsp;feature&nbsp;release of JAVA programming language development for creating business solution applications related to desktop, web, mobile, etc. Lambda expressions, the Streams API, and functional interfaces&nbsp;are some of the key productivity improvements.</p>
      <p className="text-align-justify">In this section of our tutorial, we will be covering the following topics:</p>
      <ul className="text-align-justify">
         <li>For each loop</li>
         <li>Lambda Expressions</li>
         <li>String Builder, String Buffer &amp; String Tokenizer</li>
         <li>Optional Class</li>
         <li>Stream API</li>
         <li>Functional Interface</li>
      </ul>
   </div>
 </Java8FeaturesWrapper>
);

export default Java8Features;
